export default "__VITE_ASSET__DdEYghyf__"